const mutationTypes = {
  SET_PROJECT: 'SET_PROJECT',
  CLEAR_PROJECT: 'CLEAR_PROJECT',
};

const state = {
  projects: {},
};

const mutations = {
  [mutationTypes.SET_PROJECT]: (state, action) => {
    state.projects[action.id] = action.project;
  },
  [mutationTypes.CLEAR_PROJECT]: (state) => {
    state.projects = {};
  },
};

const actions = {
  setProject: ({ commit }, action) => {
    commit(mutationTypes.SET_PROJECT, action);
  },
  clearProjects: ({ commit }, action) => {
    commit(mutationTypes.CLEAR_PROJECT, action);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
